import {Directive, ElementRef, HostListener,} from '@angular/core';

@Directive({
  selector: '[appPhoneMask]',
  standalone: true
})
export class PhoneMaskDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput() {
    const input = this.el.nativeElement as HTMLInputElement;
    let value = input.value;

    if (value.startsWith('+')) {
      value = '+' + value.slice(1).replace(/\D/g, '');
    } else {
      value = value.replace(/\D/g, '');
    }

    input.value = value;
  }
}
